import { css } from 'linaria';

export const legalDisclaimerSection = css`
  padding: 0;
  margin-top: 40px;

  @media (--to-tablet) {
    width: calc(100% - 2 * var(--space-200));
    margin-top: 9px;
    margin-right: var(--space-200);
    margin-bottom: var(--space-200);
    margin-left: var(--space-200);
  }

  p {
    margin: 0;
    font-weight: normal;
    font-size: 12px;
    font-style: normal;
    line-height: 16px;
    color: #999999;

    @media screen and (min-width: 1200px) {
      width: 780px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1199px) {
      width: 700px;
    }

    @media screen and (min-width: 768px) and (max-width: 1023px) {
      width: 100%;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }
`;
